/* src/app/admin/client/create-or-update-client.component.scss */
.action-bar {
  margin-bottom: 10px;
}
/*# sourceMappingURL=create-or-update-client.component-UISTPNL6.css.map */
